// utils/validadores.ts

import { Leads } from "../../../interfaces/Leads";

export function validarDados(lead: Partial<Leads>): boolean {
  const nomeValido =
    typeof lead.nome === "string" && lead.nome.trim().length >= 3;

  const celularLimpo = String(lead.celular || "").replace(/\D/g, "");
  const celularValido = /^\+?[1-9]\d{7,14}$/.test(celularLimpo);

  return nomeValido && celularValido;
}

export function validarCodigoSMS(codes: string[]): boolean {
  return codes.length === 6 && codes.every((code) => /^\d$/.test(code));
}

export function validarCampos<T>(
  valores: Partial<T>,
  campos: (keyof T)[]
): boolean {
  return campos.every((campo) => {
    const valor = valores[campo];
    return valor !== undefined && valor !== null;
  });
}
